/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentHeader.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useMemo } from 'react';
import { LearningContentPageHeader } from '../../learningContent/components/LearningContentPageHeader.migrated';
import { SocialShareDropdown } from '../../share/index.migrated';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CardMenuIcon from 'academy-common-lib/features/cardMenu/components/CardMenuIcon';
import { DesktopRatingsContainer, useGetPreviousReview } from '../../ratingsAndReview';
import { useUserInfo } from '../../accounts';
import { useCurrentVideoTime } from '../../video/components/VideoPlayerWithControls.migrated';
import { AcademyRatingsTypes } from '../../../constants/RatingsAndReviewConstants.migrated';
import { useIsHubspotPlaylist } from 'academy-common-lib/features/savedItems/savedItemsHooks';
import { View } from 'foundations-components/transitional/components/View';
import { maybePlaylistCardModelWithProgress } from 'academy-common-lib/features/playlist/playlistUtils';

/**
 * The number of seconds to wait before showing the ratings container
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RATINGS_CONTAINER_PROGRESS_TIMEOUT = 10;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentHeader.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ShortContentHeader = ({
  short,
  playlist,
  playlistProgress
}) => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const {
    currentVideoTime
  } = useCurrentVideoTime();
  const {
    userInfo
  } = useUserInfo();
  const {
    previousReview
  } = useGetPreviousReview({
    entityId: short === null || short === void 0 ? void 0 : short.id,
    reviewTypes: [AcademyRatingsTypes.ACADEMY_ON_THE_GO],
    reviewerUserId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.id
  });
  const isHubspotPlaylist = useIsHubspotPlaylist(playlist);
  const showRatings = useMemo(() => !isTablet && (previousReview || currentVideoTime > RATINGS_CONTAINER_PROGRESS_TIMEOUT), [previousReview, currentVideoTime, isTablet]);
  if (!short) return null;
  const {
    name,
    id: shortId
  } = short;
  const instructorIds = short.professors.map(instructor => instructor.id);
  const ratingsAdditionalTrackingData = Object.assign({
    contentLanguage: short.language,
    contentName: short.name,
    creatorHubId: short.hubId,
    hsSoftwareFilters: short.hubSpotSoftwareTools,
    professorId: instructorIds,
    subCategory: short.subCategories,
    useCases: short.useCases,
    videoProgress: currentVideoTime,
    isHubspotPlaylist
  }, playlist && {
    playlistId: playlist.id,
    playlistName: playlist.name
  });
  const playlistCardModel = maybePlaylistCardModelWithProgress(playlist, playlistProgress);
  return /*#__PURE__*/_jsx(LearningContentPageHeader, {
    item: {
      id: shortId,
      type: 'SHORT_FORM_CONTENT',
      playlistId: playlist === null || playlist === void 0 ? void 0 : playlist.id
    },
    playlist: playlist,
    playlistProgress: playlistProgress,
    title: name,
    children: isMobile ? /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(CardMenuIcon, {
        item: short,
        parentPlaylist: playlistCardModel,
        placement: "bottom left"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [showRatings && /*#__PURE__*/_jsx(DesktopRatingsContainer, {
        additionalTrackingData: ratingsAdditionalTrackingData,
        contentId: shortId,
        reviewType: AcademyRatingsTypes.ACADEMY_ON_THE_GO,
        visibility: short.visibility
      }), /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(CardMenuIcon, {
          item: short,
          parentPlaylist: playlistCardModel,
          placement: "bottom left"
        })
      }), /*#__PURE__*/_jsx(SocialShareDropdown, {
        item: short,
        parentPlaylist: playlistCardModel
      })]
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentHeader.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default ShortContentHeader;